import React, { useEffect, useState } from 'react';
import { Layout, Typography } from 'antd';
import chm from './CatalogHeaderMenu.module.scss';
import Link from 'next/link';
import { QueryService } from 'tkmp-lib/src/services/QueryService';
import useLocalization from 'tkmp-lib/src/hooks/useLocalization';
import { RightOutlined } from 'tkmp-lib/src/icons/icons';

// @ts-ignore
const CatalogCategory = ({
    categoryName,
    subCategories,
    isShowCatalogHeaderMenu,
    setIsShowCatalogHeaderMenu,
}: any) => {
    const LOCALIZATION = useLocalization();
    return (
        <div className={chm.catalogCategoryContainer}>
            <span className="text-32-500">
                {categoryName !== ''
                    ? categoryName
                    : LOCALIZATION.catalog_header_menu.choose_category}
            </span>
            <Layout className={chm.countCard}>
                {subCategories?.inner?.map((el: any) => {
                    return (
                        <Link
                            key={el?.name}
                            href={`/catalog/${el.fpathSlug.slice(1).join('/') ?? ''}`}
                            type="text"
                            className={chm.cardName}
                            onClick={() => {
                                setIsShowCatalogHeaderMenu(false);
                            }}
                        >
                            <Typography.Text className="text-16-500">{`${el?.name}`}</Typography.Text>
                            <Typography.Text className="text-14-400 text-[#5A5B5C] whitespace-nowrap">
                                {el?.count}
                            </Typography.Text>
                        </Link>
                    );
                })}
            </Layout>
        </div>
    );
};

// @ts-ignore
const CatalogHeaderMenu = ({ isShowCatalogHeaderMenu, setIsShowCatalogHeaderMenu }) => {
    const [fetchCategories, setFetchCategories] = useState<any>([]);
    const [categories, setCategories] = useState([]);
    const [items, setItems] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const LOCALIZATION = useLocalization();
    const [subCategories, setSubCategories] = useState<any>([]);
    const [currentCategoryName, setCurrentCategoryName] = useState('');

    // Единый эффект для загрузки категорий
    useEffect(() => {
        let isMounted = true;

        const loadCategories = async () => {
            try {
                const response = await QueryService.request(
                    `${process.env.NEXT_PUBLIC_DOMAIN_BFF}/tkmp/v1/${LOCALIZATION.locale}/catalog/category/home`,
                );

                if (!isMounted) return;

                setFetchCategories(response);

                const newCategories = response?.inner?.map((el: any) => ({
                    key: el?.cid,
                    cid: el?.cid,
                    name: el?.name,
                    slug: el?.slug,
                }));

                setCategories(newCategories);

                if (newCategories?.length > 0) {
                    const firstCategory = newCategories[0];
                    setSelectedCategory(firstCategory.cid);
                    setCurrentCategoryName(firstCategory.name); // Устанавливаем имя сразу
                }
            } catch (error) {
                console.error('Ошибка при загрузке категорий:', error);
            }
        };

        loadCategories();

        return () => {
            isMounted = false;
        };
    }, [LOCALIZATION.locale]);

    // Эффект для загрузки подкатегорий
    useEffect(() => {
        let isMounted = true;

        const loadSubCategories = async () => {
            if (!selectedCategory) return;

            try {
                const category = fetchCategories?.inner?.find(
                    (f: any) => f.cid === selectedCategory,
                );

                if (!category || !isMounted) return;

                setCurrentCategoryName(category.name); // Обновляем имя категории

                const response = await QueryService.request(
                    `${process.env.NEXT_PUBLIC_DOMAIN_BFF}/tkmp/v1/${LOCALIZATION.locale}/catalog/category/${category?.fpathSlug?.join('/')}`,
                );

                if (!isMounted) return;

                setSubCategories([
                    {
                        category_id: selectedCategory,
                        category_title: category.name,
                        category_childrens: response,
                    },
                ]);

                setItems(response);
            } catch (error) {
                console.error('Ошибка при загрузке подкатегорий:', error);
            }
        };

        loadSubCategories();

        return () => {
            isMounted = false;
        };
    }, [selectedCategory, LOCALIZATION.locale, fetchCategories]);

    return (
        <Layout className={chm.container}>
            <Layout
                style={{
                    overflowY: 'auto',
                    width: '100%',
                    minWidth: '300px',
                    maxWidth: '340px',
                    border: '1px solid #F0F3F5',
                    background: '#FFFFFF',
                }}
            >
                {categories?.map(
                    (
                        el: {
                            slug: any;
                            cid: React.SetStateAction<string>;
                            name: any;
                        },
                        i: any,
                    ) => {
                        return (
                            <Link
                                key={i}
                                href={`/catalog/${el.slug}`}
                                className={`${chm.menuItem} ${selectedCategory === el.cid ? chm.menuItemSelected : ''}`}
                                onMouseEnter={() => {
                                    setItems([]);
                                    setSelectedCategory(el.cid);
                                }}
                                onClick={() => {
                                    setIsShowCatalogHeaderMenu(false);
                                }}
                            >
                                {el.name}
                                {<RightOutlined />}
                            </Link>
                        );
                    },
                )}
            </Layout>
            <CatalogCategory
                isShowCatalogHeaderMenu={isShowCatalogHeaderMenu}
                setIsShowCatalogHeaderMenu={setIsShowCatalogHeaderMenu}
                categoryName={
                    currentCategoryName || LOCALIZATION.catalog_header_menu.choose_category
                }
                subCategories={
                    subCategories?.find((f: any) => f.category_id === selectedCategory)
                        ?.category_childrens
                }
            />
        </Layout>
    );
};
export default CatalogHeaderMenu;
